import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Collection } from '@share/interfaces';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useAPI } from 'src/hooks';
import { useInfiniteQuery } from 'react-query';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { web3 } from '@state/web3';
import MiniCollectionCard from '@com/card/MiniCollectionCard';

interface Props {
  isRender: boolean;
  isStop: boolean;
}

function CollectionList(props: Props): JSX.Element {
  /* Define state / hook */
  const { isStop, isRender } = props;
  const { chainId } = web3.useContainer();
  const { uuid } = useParams();
  const { t } = useTranslation();
  const { getUserCollection } = useAPI();
  const { data, isSuccess } = useInfiniteQuery<
    any,
    unknown,
    any,
    [string, { chainId: number; uuid: string }]
  >([getUserCollection.name, { chainId, uuid: uuid! }], getUserCollection, {
    getNextPageParam: (lastPage) => {
      return lastPage?.next_cursor;
    },
    enabled: isRender && !isStop && uuid !== null,
  });
  /* Custom Data Object for render or other usages */

  /* Render control function / logic */

  /* Data Change Listeners - useEffect/useMemo/useCallback */
  const isEmptyList = useMemo(
    () => data?.pages?.length === 1 && data?.pages[0]?.data?.length === 0,
    [data]
  );

  /* Styling */

  /* Render */
  return !isEmptyList && isSuccess ? (
    <div className="w-100 mb-5">
      <h2 className="mb-5">{t('profile.collection')}</h2>
      {data && data.pages?.length > 0 && (
        <Swiper
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            767: {
              slidesPerView: 2,
            },
            991: {
              slidesPerView: 3,
            },
            1440: {
              slidesPerView: 4,
            },
          }}
          spaceBetween={30}
        >
          {data?.pages?.map((page) =>
            page?.data?.map(
              (item: Collection, index: number) =>
                item && (
                  <SwiperSlide key={index} className="p-3">
                    <MiniCollectionCard item={item} />
                  </SwiperSlide>
                )
            )
          )}
        </Swiper>
      )}
      <h2 className="mb-5 mt-5">{t('profile.item')}</h2>
    </div>
  ) : (
    <div />
  );
}

export default CollectionList;
